import { BounceEmaLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BounceEmaLine';
import { BounceEmaTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/BounceEmaTacticPanel';
import BounceEmaWrapper from '../../../../components/displays/tradeplans/softOrderModules/setupModules/BounceEmaModule/wrapper/BounceEmaWrapper';
import BounceEmaDoc from '../../../../components/forms/tradeplans/documentation/BounceEmaDocumentation';
import { BounceEmaData } from './bounceEmaData';
import { validateBounceEma } from './validateBounceEma';



export const BounceEma = {
  //data class
  dataStore: BounceEmaData,

  //string constants
  name: 'BOUNCE_EMA',
  tacticLabel: 'Bounce EMA',
  addTacticLabel: 'Add Bounce EMA',
  category: 'Setup',

  //components
  tradePlanFormModule: null,
  tacticPanel: BounceEmaTacticPanel,
  addTacticPanel: null,
  wrapper: BounceEmaWrapper,
  chartSoftOrderComponent: BounceEmaLine,
  documentation: BounceEmaDoc,
  alertDetailsComponent: null, //todo

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateBounceEma
};
